<template>
<div>
  <div class="columns is-multiline" v-if="visible && order_product.length>0">
    <div class="flex-between col-12" style="padding:10px;margin-bottom:12px">
      <div style="font-size:18px">반품으로 변경 사유</div>
      <i class="material-icons unselect" @click="clickClose">close</i>
    </div>
    <div class="column is-full"  v-for="(op,idx) in order_product" :key="'op-'+idx"
      style="margin-bottom:40px">
      <admin-form-item label="교환 상품" style="margin-bottom:20px">
        <table class="delivery-orderproduct-table">
          <thead>
          <tr>
            <th style="width:35%">주문 상품</th>
            <th style="width:15%">옵션 단가</th>
            <th style="width:10%">수량</th>
            <th style="width:15%">할인 금액</th>
            <th style="width:25%">주문 상태</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="flex align-center">
                <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
                <div style="text-align: left">
                  <div v-if="op.order_product_option.length>0">
                    <div>{{ op.product.name }}</div>
                    <div style="color:#C1C1C1;font-size:14px"
                         v-for="(option, option_idx) in op.order_product_option"
                         :key="'option-'+option_idx">
                      <span v-if="option.option.option_type===0">기본옵션:</span>
                      <span v-if="option.option.option_type===1">추가옵션:</span>
                      {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                    </div>
                  </div>
                  <div v-else>
                    {{ op.product.name }} {{ op.quantity }}개
                  </div>
                </div>
              </div>

            </td>
            <td>{{ op.total_price | currency }}</td>
            <td>{{ op.quantity }}</td>
            <td>{{ op.discount_price | currency }}</td>
            <td>{{ op.status_kor }}</td>
          </tr>
          </tbody>
        </table>
      </admin-form-item>

      <admin-form-item label="반품으로 변경 사유">
        <div class="is-full flex">
          <textarea class="textarea"
            rows="6"
            cols="10"
            placeholder="상세 사유로 작성한 내용은 구매자에게 전달됩니다."
            v-model="op.change_reason"></textarea>
        </div>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <div class="flex justify-center" style="margin-top:60px">
        <button class="button is-primary" style="margin-left:6px;" @click="saveData">거부사유 입력</button>
      </div>
    </div>
  </div>

  <div class="is-multiline" v-if="!visible">
    <div style="padding:40px 0 60px;text-align:center;font-weight:700">
      <div>창을 닫을 시에는 변경 내용이 저장되지 않습니다.</div>
      <div>창을 닫으시겠습니까?</div>
    </div>

    <div class="flex-center">
      <button class="button is-primary" @click="visible=true" style="margin-right:20px">돌아가기</button>
      <button class="button is-light" @click="$modal.hide('returnChangeModal')">닫기</button>
    </div>
  </div>
</div>
</template>

<script>
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    components: {
      LpCheckBool,
      LpRadio,
      AdminFormItem},
    name: "return-change",
    props: {
      products: {
        type: Array,
        required: true
      },
    },
    data () {
      return {
        is_modify: false,
        order_product: [],
        visible: true
      }
    },
    created () {
      let order_product = this.cloneItem(this.products);
      order_product.forEach(item => {
        item.change_reason = '';
      });
      this.order_product = order_product;
    },
    watch: {
    },
    computed: {
    },
    methods: {
      saveData () {
        let product = this.cloneItem(this.order_product);
        console.log(product)
        // this.order_product.forEach(item => {
        //   id_list.push(item.id)
        // });
        this.$axios.post(this.getUrl(`delivery/orderproduct/exchange/change`), product).then(res => {
          if(res.status===200) {
            this.toast('저장되었습니다')
            this.$emit('confirm')
          }
        })
      },
      clickClose() {
        this.visible = false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    border-bottom-width thin !important
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
    background-color #eee
</style>
